// @ts-nocheck
import React from 'react'
import PropTypes from 'prop-types'
import DealsSection from './DealsSection'
import { getTranslatedTextByKey } from '../../../utils/utils'
import SmartGrid from '../../../components/common/SmartGrid/SmartGrid'

const DealsAndOffersSection = ({ list, onBannerAndOfferClick }) => {
	const getTitle = getTranslatedTextByKey('eCommerce.deals.dealsAndOffers', 'offers & deals')

	return (
		<DealsSection title={getTitle} testId="deals-and-offers-title">
			<SmartGrid list={list} onBannerAndOfferClick={onBannerAndOfferClick} />
		</DealsSection>
	)
}

DealsAndOffersSection.propTypes = {
	list: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
	onBannerAndOfferClick: PropTypes.func,
}

export default DealsAndOffersSection
